<template>
  <div class="page">
    <div class="page-center">
      <img src="../assets/404.svg" />
      <div class="tips">咦! 页面飞去哪儿了~<br><a href="">回到首页</a><a href="window.go">返回上一页</a></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  components: {
  },
  data() {
    return {
      interval: null,
      code: null,
      qrcode: null,
      status: 0,
      message: "",
      verifying: false,
    }
  },
  mounted() {
  },
  methods: {
    home() {
      this.$router.replace('home')
    },
    back() {
      this.$router.go(-1);
    },
  },
}
</script>

<style lang="scss" scope>
@import '@/scss/public.scss';

.page {
  -webkit-box-flex: 1;
  background: $color-board;

  .page-center {
    margin: auto;
    position: absolute;
    width: 240px;
    height: 320px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    img {
      width: 240px;
    }

    .tips {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      color: $color-gray;

      a {
        display: inline-block;
        padding: 2px 5px;
        color: $color-type-transfer;
        text-decoration: none;
      }
    }
  }
}

</style>
